import { formatDateWithTimeAndDate } from '../../../utils/formatDate'

interface IAnnounement {
  title: string
  description: string
  publishedAt: string
}

export const Announcement = ({
  title,
  description,
  publishedAt,
}: IAnnounement) => {
  const date = new Date(publishedAt)
  const dayCount = date.getDate()
  const day = date.getDay()
  const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

  return (
    <div className='bg-gray-700 px-4 py-4 rounded-lg'>
      <div className='flex flex-wrap gap-2'>
        <div className='inline-flex bg-gray-500 px-5 py-2 rounded-lg flex-col'>
          <p className='text-xs text-white'>{weekDays[day]}</p>
          <h3 className='text-xl text-white font-extrabold'>{dayCount}</h3>
        </div>
        <div className='flex flex-col gap-1'>
          <h3 className='text-white text-base'>{title}</h3>
          <p className='text-white/30 text-xs line-clamp-2'>{description}</p>
          <p className='mt-3 text-xs text-white/30'>
            {formatDateWithTimeAndDate(publishedAt)}
          </p>
        </div>
      </div>
    </div>
  )
}
